import { Chip } from "@mui/material";

const STATUS_MAP: Record<number, { text: string; color: string }> = {
  1: { text: "Active", color: "#ADFFB2" },
  2: { text: "Canceled", color: "#E0E0E0" },
  3: { text: "Inactive", color: "#FFAEAE" },
};

export default function BadgeSubscription(props: any) {
  const { status_id = 1 } = props;

  const statusData = STATUS_MAP[status_id] ?? STATUS_MAP[1];

  return (
    <Chip
      label={statusData.text}
      className="order-details-status"
      style={{
        borderRadius: "5px",
        fontSize: "14px",
        backgroundColor: statusData.color,
        color: "#424242",
        fontWeight: "400",
        height: "29px",
      }}
    />
  );
}
